const smishing = {
  slug: 'smishing',
  title: 'SMS scams (smishing)',
  description:
    'Recognize scam texts about deliveries, banks, and prizes. Same rules as phone scams: do not click links or share codes.',
  category: 'scams',
  guideType: 'guide',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['red-flags', 'what-not-to-do', 'two-factor-authentication'],
  sections: [
    {
      type: 'paragraph',
      text: 'Smishing is phishing by SMS. The message creates urgency and includes a link or a request to reply or call a number.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Common smishing themes',
    },
    {
      type: 'list',
      items: [
        'Failed delivery or customs fee for a package you did not order',
        '“Unusual activity” on your bank or payment account',
        'Prize wins, tax refunds, or toll-road fines',
        'Shortened links that hide the real destination',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'What to do instead of tapping the link',
    },
    {
      type: 'list',
      items: [
        'Open the courier or bank app directly, or type the official website yourself',
        'Call the number on your card — not the number in the text',
        'Report the message to your carrier and national scam reporting (see regional resources)',
      ],
    },
    {
      type: 'warning',
      text: 'Malicious links can install malware or steal login credentials in one tap.',
    },
    {
      type: 'link',
      to: '/learn/two-factor-authentication',
      label: 'Strengthen accounts with two-factor authentication',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default smishing;
